module.exports = __webpack_public_path__ + "static/21-3359ef6317508dff1ad302f59b90deea.jpg";